import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ahsan Shaikh </span>
            from <span className="purple"> Hyderabad, Pakistan</span>
            <br /> I'm doing my 7th Semester in Software Engineering from
            <br />University of Sindh.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Learning is the only option to create something!"{" "}
          </p>
          <footer className="blockquote-footer">Ahsan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
